<template>
    <section>
        Not Found.
    </section>
</template>

<script>
    export default {
        name: "not-found"
    }
</script>

<style scoped>

</style>